"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_geocoder_1 = __importDefault(require("./abstract-geocoder"));
/**
 * Allows fetching results from OTP instance with the geocoder endpoint enabled
 */
var OTPGeocoder = /** @class */ (function (_super) {
    __extends(OTPGeocoder, _super);
    function OTPGeocoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OTPGeocoder.prototype.getAutocompleteQuery = function (query) {
        var baseUrl = this.geocoderConfig.baseUrl;
        return __assign({ url: baseUrl }, query);
    };
    OTPGeocoder.prototype.rewriteAutocompleteResponse = function (response) {
        var _a;
        return {
            features: (_a = response === null || response === void 0 ? void 0 : response.results) === null || _a === void 0 ? void 0 : _a.map(function (stop) { return ({
                geometry: { type: "Point", coordinates: [stop.coordinate.lng, stop.coordinate.lat] },
                id: stop.id,
                // TODO: if non-stops are supported, these need to be detected here and 
                // this layer property updated accordingly
                properties: { layer: "stops", source: "otp", name: stop.name, label: stop.code },
                type: "Feature"
            }); }),
            type: "FeatureCollection"
        };
    };
    return OTPGeocoder;
}(abstract_geocoder_1.default));
exports.default = OTPGeocoder;
//# sourceMappingURL=otp.js.map